module.exports = __webpack_public_path__ + "img/Cedis-Mexicali.7c276cfe.jpg";